<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page">
  <div class="bb-page-shell">

    <!-- HEADER -->
    <div class="bb-page-header">
      <div class="bb-page-title-block">
        <span class="bb-eyebrow">{{ 'delivery hero collecting' | transloco }}</span>
        <h2 class="bb-page-title">{{ 'delivery hero collecting' | transloco }}</h2>
        <p class="bb-page-subtitle">{{ 'deliveryhero' | transloco }}</p>
      </div>

      <div class="bb-header-actions noPrint">
        @if(isAdmin){
        <div class="dropdown">
          <button class="bb-btn bb-btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">
            {{ "Pospage" | transloco }}
          </button>

          <ul class="dropdown-menu">
            <li>
              <a class="dropdown-item" (click)="applyWareHouse(el.id)" *ngFor="let el of allWareHouses">
                {{ el.name }}
              </a>
            </li>
          </ul>
        </div>
        }

        <button class="bb-btn bb-btn-secondary" onclick="window.print()">
          {{ 'Print' | transloco }}
        </button>
      </div>
    </div>

    <!-- FILTERS -->
    <div class="bb-filter-card noPrint">
      <div class="bb-form-grid">

        <div class="bb-field">
          <label class="bb-label">{{ 'deliveryhero' | transloco }}</label>
          <div class="bb-select-wrap">
            <select class="bb-select" [(ngModel)]="herosd" (change)="filterAllHeros()">
              <option *ngFor="let hero of heros" [value]="hero.phone ?? hero.link ?? hero.id">
                {{ hero.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="bb-field">
          <label class="bb-label">{{ 'byday' | transloco }}</label>
          <input class="bb-input" [(ngModel)]="date" (change)="dayChange()" type="date" />
        </div>

      </div>
    </div>

    <!-- SUMMARY -->
    <div class="finance-summary-grid">

      <div class="finance-summary-card finance-summary-card-net">
        <div class="finance-summary-card-head">
          <h6>{{ 'total' | transloco }}</h6>
        </div>
        <h3 class="finance-value-success">
          {{ totalCollected | number:'1.2-2' }} {{ 'egp' | transloco }}
        </h3>
      </div>

      <div class="finance-summary-card">
        <div class="finance-summary-card-head">
          <h6>{{ 'Orders' | transloco }}</h6>
        </div>
        <h3 class="bb-text-navy">
          {{ totalCount }}
        </h3>
      </div>

      <div class="finance-summary-card">
        <div class="finance-summary-card-head">
          <h6>{{ 'amount' | transloco }}</h6>
        </div>
        <h3 class="finance-value-success">
          {{ totalAmount | number:'1.2-2' }} {{ 'egp' | transloco }}
        </h3>
      </div>

    </div>

    <!-- TABLE -->
    <div class="finance-tables-grid">

      <div class="finance-table-card finance-table-full">

        <h5 class="finance-table-title bb-text-success">
          {{ 'delivery hero collecting' | transloco }}
        </h5>

        <div class="bb-empty-state" *ngIf="hasData">
          <app-nodata></app-nodata>
        </div>

        <div class="finance-table-scroll" *ngIf="!hasData">
          <table class="finance-table">
            <thead>
              <tr>
                <th>{{ 'amount' | transloco }}</th>
                <th>{{ 'Orders' | transloco }}</th>
                <th>{{ 'deliveryhero' | transloco }}</th>
                <th class="finance-actions-cell noPrint"></th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let value of collectedFromDH">

                <td>
                  <span class="finance-main-text finance-value-success">
                    {{ value.amount_collected | number:'1.2-2' }} {{ 'egp' | transloco }}
                  </span>
                </td>

                <td>
                  {{ value.order_id }}
                </td>

                <td>
                  0{{ value.sub_dilivery_id }}
                </td>

                <td class="finance-actions-cell noPrint">
                  <button (click)="delete(value.id)" class="finance-delete-btn">
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </td>

              </tr>
            </tbody>
          </table>
        </div>

      </div>

    </div>

    <!-- ================= CHARTS ================= -->
    <!--
    <div class="finance-tables-grid bb-mt-20">

      <div class="finance-table-card">
        <h5 class="finance-table-title">Daily Revenue</h5>
        <div class="bb-p-20">
          <canvas baseChart [data]="dailyChart" [type]="'line'"></canvas>
        </div>
      </div>

      <div class="finance-table-card">
        <h5 class="finance-table-title">Top Delivery Hero</h5>
        <div class="bb-p-20">
          <canvas baseChart [data]="heroChart" [type]="'bar'"></canvas>
        </div>
      </div>

      <div class="finance-table-card">
        <h5 class="finance-table-title">Orders Distribution</h5>
        <div class="bb-p-20">
          <canvas baseChart [data]="ordersChart" [type]="'pie'"></canvas>
        </div>
      </div>

      <div class="finance-table-card">
        <h5 class="finance-table-title">Monthly Revenue</h5>
        <div class="bb-p-20">
          <canvas baseChart [data]="monthlyChart" [type]="'line'"></canvas>
        </div>
      </div>

    </div>
    -->

  </div>
</section>